export class Bill {
    id              : number;
    title           : string;
    provider_id     : number;
    company_name    : string;
    control_no      : string;
    invoice_date    : string;
    invoice_no      : string;
    fleet_id        : number;
    rego            : string;
    fleet_id_num    : string;
    due_date        : string;
    bill_period_fr  : string;
    bill_period_to  : string;
    total_amount    : number;
    gst             : number;
    currency_id     : string;
    bill_status_id  : number;
    created_by      : number;
    updated_by      : number;
    created_at      : string;
    updated_at      : string;
    paid_amount     : number;
    cancelled_date  : string;
    bill_items      : BillItem[];
 }
 
export class BillPayment {
    id              : number;
    bill_id         : number;
    date            : string;
    description     : string;
    file            : string;
    paid_amount     : number;
    payment_type_id : number;
    reference_no    : string;
    created_by      : number;
    updated_by      : number;
}

export class BillNote {
    id              : number;
    bill_id         : number;
    notes           : string;
    created_by      : number;
    user_name       : string;
    created_at      : string;
    updated_at      : string;
}

export interface BillStatus {
    id         : number;
    name       : string;
    description: string;
    created_at : string;
    updated_at : string;
}

export interface BillType {
    id         : number;
    name       : string;
    description: string;
    created_by : number;
    updated_by?: number;
    created_at : string;
    updated_at?: string;
}

export interface BillItem {
    id              : number;
    bill_id         : number;
    bill_type_name ?: number;
    bill_type_id    : number;
    description     : string;
    quantity        : number;
    unit_price      : number;
    item_date      ?: string;
    gst            ?: boolean;
    reference_no   ?: string;
    file           ?: string;
    amount          : number;
    created_by      : number;
    updated_by      : number;
    created_at      : string;
    updated_at      : string;
    expense_records : ExpenseRecord[];
}

export class ExpenseRecord {
    id                  : number;
    bill_item_id        : number;
    expense_record_id   : number;
    table_name          : string;
}
